import { createFileRoute } from '@tanstack/react-router';

import { ProductionPlannerTimelineView } from '../../features/production-planner/production-planner-timeline-view';

export const Route = createFileRoute('/production-planner/timeline')({
  staticData: {
    // section and layout ("full-height") are inherited from the parent
    // `/production-planner` layout route, which also contributes the
    // "Production Planner" crumb — this leaf crumb makes the trail read
    // "Production Planner > Timeline" so the two views stay distinguishable.
    breadcrumb: 'Timeline',
  },
  component: ProductionPlannerTimelineView,
});
